export class BaseMachine {
  get state() {
    return { ...this.nextState }
  }
  getState () {
    return { ...this.nextState }
  }
}
